import { paddingMedium } from "src/styles/spacing";

export const TAG_BORDER_RADIUS = 8;
export const TAG_HORIZONTAL_PADDING = paddingMedium;
export const TAG_VERTICAL_PADDING = paddingMedium;
